import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconShareArrowSvg } from "./IconShareArrowSvg.mjs";
const IconShareArrow = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconShareArrowSvg, ...iconProps });
};
export {
  IconShareArrow
};
